import React, { useState } from 'react';
import styles from '../stylesheets/Navbar.module.scss'
import NavItem from './NavItem'
import { FaBars } from 'react-icons/fa';

const Navbar = ({activeSection}) => {
  const [opened, setOpened] = useState(false)


  const toggleMenuHandler = () => {
    setOpened(!opened)
  }




    return (
      <nav className={styles.navbar}>
        <FaBars
          className={styles.icon}
          onClick={toggleMenuHandler}
        />
        <div className="container">
          <ul className={
            styles.links + " " + (opened ? styles.opened : styles.closed)
          }>
            <li className={styles.link}>
              <NavItem
                text="HOME"
                target="#home"
                appendClass={activeSection === 0 ? ' active' : ''}
                activeSection={activeSection} />
            </li>
            <li className={styles.link}>
              <NavItem
                text="ABOUT"
                target="#about"
                appendClass={activeSection === 1 ? ' active' : ''}
                activeSection={activeSection} />
            </li>
            <li className={styles.link}>
              <NavItem
                text="PORTFOLIO"
                target="#portfolio"
                appendClass={activeSection === 2 ? ' active' : ''}
                activeSection={activeSection} />
            </li>
            <li className={styles.link}>
              <NavItem
                text="CONTACT"
                target="#contact"
                appendClass={activeSection === 3 ? ' active' : ''}
                activeSection={activeSection} />
            </li>
          </ul>
        </div>
      </nav>
    );
  }


export default Navbar
